import React from 'react';
import { Link } from 'react-router-dom';
import MetaGroup from '../../components/meta-group';
import GetDemo from '../../components/CTAs/GetDemo';
import HeroImage from '../../assets/images/contact-hero.jpg';
import EdrImage from '../../assets/images/dispatchlinks/edr-interface.png';
import JobsImage from '../../assets/images/dispatchlinks/callsheet.png';
import UpdatesImage from '../../assets/images/servers.png';

import SamsungLogo from '../../assets/images/dispatchlinks/samsung-logo.svg';
import ServiceBenchLogo from '../../assets/images/dispatchlinks/servicebench-logo.png';
import ServiceLiveLogo from '../../assets/images/dispatchlinks/service-live-logo.jpg';
import ServicePowerLogo from '../../assets/images/dispatchlinks/servicepower-logo.png';
import DispatchMeLogo from '../../assets/images/dispatchlinks/dispatchme-logo.webp';
import WarrantechLogo from '../../assets/images/dispatchlinks/warrantech-logo.png';
import PcRichardLogo from '../../assets/images/dispatchlinks/pc-richard-logo.webp';
import LgLogo from '../../assets/images/dispatchlinks/lg-logo.png';
import AhsLogo from '../../assets/images/dispatchlinks/ahs-logo.png';
import FirstAmericanLogo from '../../assets/images/dispatchlinks/first-american-logo.png';
import FidelityLogo from '../../assets/images/dispatchlinks/fidelity-national-logo.jpg';
import OldRepublicLogo from '../../assets/images/dispatchlinks/old-republic-logo.png';
import IntegrationFeature from '../../components/integrations-feature';

export default class DispatchLinks extends React.Component {
	state = {
		hideExtraPricing: true
	}

	toggleExtraPricing = () => {
		const { hideExtraPricing } = this.state;
		if (hideExtraPricing) {
			this.setState({ hideExtraPricing: false });
		} else {
			this.setState({ hideExtraPricing: true });
		}
	}

	render() {
		return (
			<div>
				<MetaGroup
					title="SD-DispatchLinks - 3rd party warranty integrations"
					metaDescription="These automated services integrate you with 3rd party warranty companies such as ServiceBench, ServiceLive, Dispatch.me and more."
					ogImage="%PUBLIC_URL%/logo512.png"
				/>
				<div className="section">
					<div className="container grid-2-col lg-gap">
						<div className="d-flex flex-column justify-content-center align-items-left">
							<h1 className="display-1 mb-5"><i>Power up</i> your office with integrations</h1>
							<p className="lead pb-4">Whether you've got dispatches that come in through ServiceBench, ServiceLive, Dispatch.me or other platforms, we've got you covered.</p>
							<a href="#features" className="btn btn-primary">See features</a>
						</div>
						<div className="">
							<img src={HeroImage} alt="ServiceDesk on an Laptop" width="100%" className="hero-image-right" />
						</div>
					</div>
				</div>

				<IntegrationFeature />

				<div id="features" className="section">
					<div className="container">
						<div className="container-md mb-6">
							<h2 className="text-center mb-4">It's time to automate</h2>
							<div className="lead text-center">How much time do you spend on manual data entry?</div>
						</div>
						<div className="grid-3-col md-gap">
							<div className="image-detail-item">
								<img src={EdrImage} width="100%" alt="DispatchLinks feature - Automatic job creation" className="image-detail-image"></img>
									<h3>Connect</h3>
									<p className="">Easily connect ServiceDesk to the majority of 3rd party dispatching systems, such as ServiceBench, ServiceLive, and Dispatch.me.</p>
							</div>
							<div className="image-detail-item">
								<img src={JobsImage} width="100%" alt="DispatchLinks feature - Status updates" className="image-detail-image"></img>
									<h3>Receive jobs</h3>
									<p className="">Jobs are created automatically in ServiceDesk when a dispatch is received from the 3rd party system.</p>
							</div>
							<div className="image-detail-item">
								<img src={UpdatesImage} width="100%" alt="DispatchLinks feature - Parts and labor" className="image-detail-image"></img>
									<h3>Automatic updates</h3>
									<p className="">Jobs status changes are automatically sent back to dispatch system.</p>
							</div>
						</div>
					</div>
				</div>

				<div className="section bg-light">
					<div className="container">
						<div className="container-md mb-6">
							<h2 className="text-center mb-4">Connect to the source of your jobs</h2>
							<div className="lead text-center mb-4">These automated services integrate you with 3rd party warranty companies such as ServiceBench, ServiceLive, Dispatch.me and more.</div>
							<div className="text-center">	
								<Link to="/demo" className="btn btn-primary mr-4">Request a demo</Link>
								<Link to="/contact" className="btn btn-outline-primary">Contact our team</Link>
							</div>
						</div>
						<div className="grid-5-col lg-gap text-center">
							<div className="integration-item">
								<img src={SamsungLogo} className="integration-icon" alt="Samsung logo"></img>
								Samsung
							</div>
							<div className="integration-item">
								<img src={ServiceBenchLogo} className="integration-icon" alt="ServiceBench logo"></img>
								ServiceBench
							</div>
							<div className="integration-item">
								<img src={ServiceLiveLogo} className="integration-icon" alt="ServiceLive logo"></img>
								ServiceLive
							</div>
							<div className="integration-item">
								<img src={ServicePowerLogo} className="integration-icon" alt="ServicePower logo"></img>
								ServicePower
							</div>
							<div className="integration-item">
								<img src={DispatchMeLogo} className="integration-icon" alt="DispatchMe logo"></img>
								DispatchMe
							</div>
							<div className="integration-item">
								<img src={WarrantechLogo} className="integration-icon" alt="Warrantech logo"></img>
								Warrantech
							</div>
							<div className="integration-item">
								<img src={PcRichardLogo} className="integration-icon" alt="PcRichard logo"></img>
								PC Richard & Son
							</div>
							<div className="integration-item">
								<img src={LgLogo} className="integration-icon" alt="Lg logo"></img>
								LG
							</div>
							<div className="integration-item">
								<img src={AhsLogo} className="integration-icon" alt="Ahs logo"></img>
								American Home Shield
							</div>
							<div className="integration-item">
								<img src={FirstAmericanLogo} className="integration-icon" alt="First American logo"></img>
								First American Home Warranty
							</div>
							<div className="integration-item">
								<img src={FidelityLogo} className="integration-icon" alt="Fidelity logo"></img>
								Fidelity National Home Warranty
							</div>
							<div className="integration-item">
								<img src={OldRepublicLogo} className="integration-icon" alt="Old Republic logo"></img>
								Old Republic Home Protection
							</div>

						</div>
					</div>
					
				</div>
				<GetDemo />
			</div>
		)
	}
}
